<template>
  <div
    id="BackgroundTaskManagement"
    class="h-full"
    v-loading="pageLoading"
    :element-loading-text="loadingText"
  >
    <el-card :body-style="{ padding: '10px', height: '100%' }" class="h-full">
      <div class="flex search-bar" ref="searchBar">
        <selectStandardId @updateStandardId="updateStandardId" />
        <el-select
          filterable
          size="small"
          v-model="taskJobStateType"
          :placeholder="$t('pleaseSelectATaskStatus')"
          clearable
          class="w-200px mr-10px ml-10px"
        >
          <el-option
            v-for="(item, index) in typeOptions"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input
          size="small"
          class="w-200px mr-10px"
          @keyup.enter.native="handleFilter"
          v-model.trim="keywords"
          :placeholder="$t('searchAssetName')"
          clearable
        ></el-input>
        <el-select
          filterable
          size="small"
          v-model="jobType"
          :placeholder="$t('pleaseChooseTheType')"
          clearable
          class="w-200px mr-10px"
        >
          <el-option
            v-for="(item, index) in jobTypeData"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-date-picker
          v-model="createdTime"
          type="daterange"
          :range-separator="$t('to')"
          :start-placeholder="$t('createStartTime')"
          :end-placeholder="$t('createEndTime')"
          value-format="yyyy-MM-dd"
          size="small"
          class="mr-10px"
        ></el-date-picker>
        <el-date-picker
          v-model="modifiedTime"
          type="daterange"
          :range-separator="$t('to')"
          :start-placeholder="$t('lastModifiedStartTime')"
          :end-placeholder="$t('lastModifiedEndTime')"
          size="small"
          class="mr-10px"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </div>
      <div class="mt-10px">
        <el-button type="primary" @click="handleFilter">{{ $t('search') }}</el-button>
        <el-button type="primary" @click="handleRefresh()">{{ $t('Refresh') }}</el-button>
        <el-button :disabled="!$hasAccess('retry')" type="primary" @click="handleBatch('retry')">{{
          $t('Retry')
        }}</el-button>
        <el-button :disabled="!$hasAccess('restore')" type="primary" @click="handleBatch('stop')">{{
          $t('Restore')
        }}</el-button>
        <el-button
          :disabled="!$hasAccess('delete')"
          type="danger"
          @click="deleteTaskJob(selectRow)"
          >{{ $t('delete') }}</el-button
        >
      </div>
      <div class="mt-20px" :style="{ height: tableHeight }">
        <el-table
          key="auth"
          :data="tableData"
          v-loading="listLoading"
          border
          height="100%"
          :highlight-current-row="true"
          @selection-change="selectionChange"
          @select-all="selectAll"
          @sort-change="sortChange"
          stripe
          ref="table"
          row-key="id"
        >
          <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
          <el-table-column prop="title" :label="$t('assetName')" min-width="130"></el-table-column>
          <el-table-column prop="stateStr" :label="$t('state')"></el-table-column>
          <el-table-column prop="taskTypeName" :label="$t('type')"></el-table-column>
          <el-table-column prop="progess" :label="$t('schedule')"></el-table-column>
          <el-table-column
            prop="createdTime"
            sortable="custom"
            :label="$t('creationTime')"
            min-width="130"
          >
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.createdTime
                    ? dayjs(scope.row.createdTime).format('YYYY/MM/DD HH:mm:ss')
                    : $t('noDateYet')
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="lastModifiedTime"
            sortable="custom"
            :label="$t('lastModified')"
            min-width="130"
          >
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.lastModifiedTime
                    ? dayjs(scope.row.lastModifiedTime).format('YYYY/MM/DD HH:mm:ss')
                    : $t('noDateYet')
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="taskResult"
            :label="$t('Result')"
            min-width="130"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column :label="$t('operate')" min-width="240" prop="status" fixed="right">
            <template slot-scope="scope">
              <el-button
                :disabled="!$hasAccess('retry')"
                size="mini"
                @click="editTask(scope.row, 'retry')"
                >{{ $t('Retry') }}</el-button
              >
              <el-button
                :disabled="!$hasAccess('restore')"
                size="mini"
                @click="editTask(scope.row, 'stop')"
                >{{ $t('Restore') }}</el-button
              >
              <!-- <el-tooltip
                :content="$t('view')"
                placement="top"
                :open-delay="1000"
              >
                <el-button
                  type="info"
                  size="mini"
                  class="m-l-0 m-r-5 iconfont icon-display"
                  @click="viewTask(scope.row)"
                ></el-button>
              </el-tooltip> -->
              <el-button
                :disabled="!$hasAccess('delete')"
                size="mini"
                @click="deleteTaskJob([scope.row])"
                >{{ $t('delete') }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="mt-20px" :style="{ height: tableHeight }" v-if="false">
        <el-table border key="noAuth" class="w-full" height="100%" row-key="id">
          <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
          <el-table-column prop="title" :label="$t('assetName')" min-width="130"></el-table-column>
          <el-table-column prop="stateStr" :label="$t('state')"></el-table-column>
          <el-table-column prop="taskTypeName" :label="$t('type')"></el-table-column>
          <el-table-column prop="progess" :label="$t('schedule')"></el-table-column>
          <el-table-column
            prop="createdTime"
            :label="$t('creationTime')"
            min-width="130"
          ></el-table-column>
          <el-table-column
            prop="lastModifiedTime"
            sortable="custom"
            :label="$t('lastModified')"
            min-width="130"
          ></el-table-column>
          <el-table-column
            prop="taskResult"
            :label="$t('Result')"
            min-width="130"
          ></el-table-column>
          <el-table-column :label="$t('operate')" min-width="181" prop="status"></el-table-column>
        </el-table>
      </div>
      <div class="mt-20px float-right">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageNo"
          :page-sizes="$pageSizeAll"
          :page-size="pageSize"
          layout="total,sizes, prev, pager, next, jumper"
          :total="recordCount"
        ></el-pagination>
      </div>
    </el-card>
    <model-view
      v-if="showModelView"
      ref="modelView"
      class="bg-white absolute -left-9999px -top-9999px"
      playerEngineId="splitEngineId"
      :cloudRender="cloudRender"
      :modelProps="modelProps"
      :showDocComponent="false"
      :modelParams="modelParams"
      :modelName="modelName"
      :basicTabBar="[]"
      :businessTabBar="[]"
      @sendPlayer="($event) => (mainPlayer = $event)"
      @LoadedAllModel="loadedAllModel"
      @loadError="loadError"
    ></model-view>
  </div>
</template>
<script type="text/ecmascript-6">
import ApiMixinTags from '@/assets/js/api/tags'
import ApiMixinBackgroundTask from '@/assets/js/api/backgroundTask'
import fnMixin from '@/assets/js/fnMixins'
import DocumentService from '@/services/DocumentService'
import { instance as cloudRender } from 'wiz-cloud-render-vulkan'
import ModelServer from '../model-file-management/services/modelServer'
import selectStandardId from '../../components/selectStandardId'

const ModelView = () => {
  return import('../../components/model/ModelViewVk')
}

export default {
  name: 'BackgroundTaskManagement',
  components: { selectStandardId, ModelView },
  data() {
    return {
      listLoading: false,
      keywords: '', // 搜索的内容
      jobType: '', // 搜索类型
      createdTime: [], // 搜索创建时间
      modifiedTime: [], // 搜索最后修改时间
      taskJobStateType: '', // 搜索类型的字段
      sortName: 'created_time', // 排序的字段
      sortType: 'desc', // 排序的方式 asc为升序, desc为降序
      pageNo: 1, // 当前的页
      pageSize: 15, // 当前的页显示数据的条数
      recordCount: 0, // 分页的总数
      tableData: [], // tab列表的数据
      selectRow: [], // 当前选中的行
      typeOptions: [], // 状态类型
      jobTypeData: [], // 类型数据
      timer: null, // 定时器
      isSelectAll: false, // 是否全选
      tableHeight: 'calc(100% - 158px)',
      //  标准部分
      standardId: localStorage.getItem('standardId'),
      systemParams: localStorage.getItem('systemParams')
        ? JSON.parse(localStorage.getItem('systemParams'))
        : [],
      modelType: [
        'pr',
        'pprj',
        'rvm',
        'fbx',
        'vue',
      ],
      modelParams: [],
      showModelView: false,
      modelProps: {},
      modelName: '',
      parseQueue: [],
      pageLoading: false,
      loadingText: '',
    }
  },
  computed: {
    config() {
      return Wiz.globalSettings.dynamicModules.modules['legacy-resource']?.config || {}
    },
    modelCenterVersion() {
      const version = _.find(this.systemParams, { parameterCode: 'modelCenterVersion' }) || {}
      return version.parameterValue
    },
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase') ? `/${Wiz.globalSettings.globalConfig.routerBase}` : ''
    },
    cloudRender() {
      return cloudRender
    },
  },
  methods: {
    async parseModelTag() {
      if (this.parseQueue.length === 0) {
        this.showModelView = false
        this.modelParams = this.$options.data().modelParams
        this.modelProps = this.$options.data().modelProps
        this.modelName = ''
        this.pageLoading = false
        this.loadingText = ''
        this.queryBackgroundTask()
        return
      }
      this.pageLoading = true
      this.loadingText = this.$t('ParsingTheModelInformationObject')
      const row = this.parseQueue.shift()
      const params = JSON.parse(row.params)
      const modelType = params.FileName.split('.').at(-1).toLowerCase()
      const fileId = params.FileIdOrigin || params.FileId
      const fileRes = await DocumentService.getDocumentFileType({
        standardId: this.standardId,
        fileId,
      })
      if (fileRes?.code === 0) {
        const name = fileRes.data.fileNameOrigin || fileRes.data.fileName
        this.modelParams = [{
          ..._.pick(fileRes.data, ['fileId', 'documentId']),
          name,
          type: modelType,
          md5: fileRes.data.fileOriginMd5,
        }]
        this.modelProps = {
          defaultModelId: fileRes.data.documentId
        }
        this.modelName = fileRes.data.documentId
        this.showModelView = true
      }
    },
    async loadedAllModel() {
      try {
        const root = await this.mainPlayer.Native.Node.getRoot()
        const children = await this.mainPlayer.Native.Node.collectChildrenWithCode(root)
        const childrenInfo = await this.mainPlayer.Native.Node.getProperty(children, ['code'])
        const tags = []
        _.forEach(childrenInfo, (item) => {
          if (item.code) {
            tags.push(item.code)
          }
        })
        await ModelServer.analysisModelTag({
          standardId: this.standardId,
          documentId: this.modelName,
          tags,
        })
        this.parseModelTag()
      } catch (error) {
        this.$message.warning(error)
        this.loadError()
      }
    },
    loadError() {
      this.parseQueue = []
      this.showModelView = false
      this.modelParams = this.$options.data().modelParams
      this.modelProps = this.$options.data().modelProps
      this.modelName = ''
      this.pageLoading = false
      this.loadingText = ''
      this.queryBackgroundTask()
    },
    updateStandardId(val) {
      this.standardId = val
    },
    async queryTaskType() {
      const res = await this.apiBackgroundTask({
        method: 'type',
      })
      if (res) {
        const list = []
        Object.keys(res).forEach((key) => {
          list.push({ name: res[key], id: key })
        })
        return list
      }
      return []
    },
    async queryJobType() {
      const res = await this.apiBackgroundTask({
        method: 'jobType',
        params: {
          Name: '',
          SkipCount: 0,
          MaxResultCount: 999,
          Sorting: `${this.sortName} ${this.sortType}`,
        },
      })
      if (res && res.code === 0 && res.data) {
        return res.data
      }
      return []
    },
    // tab列表的数据请求的方法
    async queryBackgroundTask() {
      this.listLoading = true
      const params = {
        Title: this.keywords,
        SkipCount: (this.pageNo - 1) * this.pageSize,
        MaxResultCount: this.pageSize,
        Sorting: `${this.sortName} ${this.sortType}`,
        JobState: this.taskJobStateType,
        JobType: this.jobType,
        CreateStartTime: _.isEmpty(this.createdTime) ? '' : this.createdTime[0],
        CreateEndTime: _.isEmpty(this.createdTime) ? '' : this.createdTime[1],
        ModifyStartTime: _.isEmpty(this.modifiedTime) ? '' : this.modifiedTime[0],
        ModifyEndTime: _.isEmpty(this.modifiedTime) ? '' : this.modifiedTime[1],
        standardId: this.standardId,
      }
      const dataList = await this.apiBackgroundTask({
        method: 'list',
        params,
      })
      if (dataList && dataList.code === 0 && dataList.data) {
        this.listLoading = false
        this.recordCount = dataList.totalCount
        _.map(dataList.data, (item, index) => {
          _.forEach(this.jobTypeData, (type) => {
            if (item.taskInfoId === type.id) {
              this.$set(dataList.data[index], 'taskTypeName', type.name)
              this.$set(dataList.data[index], 'taskType', type.type)
            }
          })
          return item
        })
        this.tableData = dataList.data
        this.$nextTick(() => {
          this.$refs.table.doLayout()
        })
      }
      this.listLoading = false
    },
    // 按下回车键搜索、 搜索按钮
    async handleFilter() {
      this.pageNo = 1
      if (this.$refs.table) {
        this.$refs.table.clearSelection()
      }
      this.queryBackgroundTask()
      this.isSelectAll = false
      this.refreshProcess()
    },
    //  每页条数
    async handleSizeChange(val) {
      this.pageSize = val
      this.queryBackgroundTask()
      this.isSelectAll = false
      this.refreshProcess()
    },
    // 分页
    async handleCurrentChange(val) {
      this.pageNo = val
      this.queryBackgroundTask()
      this.isSelectAll = false
      this.refreshProcess()
    },
    // 刷新页面
    async handleRefresh() {
      this.queryBackgroundTask()
      this.isSelectAll = false
      this.refreshProcess()
    },
    // 全选
    selectAll() {
      this.isSelectAll = !this.isSelectAll
      if (!this.isSelectAll) {
        this.$refs.table.clearSelection()
      }
    },
    // 勾选要操作的数据
    selectionChange(selection) {
      this.selectRow = []
      let hasPdfToOcr = false
      _.forEach(selection, (i) => {
        if (i.state === 4 && i.taskType === 'PdfFileOcrConvertJob') {
          hasPdfToOcr = true
          this.$refs.table.toggleRowSelection(i, false)
        } else {
          this.selectRow.push(i)
        }
      })
      if (hasPdfToOcr && !this.isSelectAll) {
        this.$message.warning(
          `${this.$t('theCompletedPdfFileConversionOcrTypeCanNoLongerBeOperated')}!`
        )
      }
    },
    // 排序
    async sortChange(column) {
      if (column.column === null) {
        return
      }
      if (column.prop === 'taskTypeName') {
        this.sortName = 'jobType'
      }
      // if (column.prop === 'taskJobStateStr') {
      //   this.sortName = 'taskJobState'
      // }
      this.sortName = fnMixin.methods.humpToUnderline(column.prop)
      if (column.order === 'ascending') {
        this.sortType = 'asc'
        this.queryBackgroundTask()
        this.isSelectAll = false
        this.refreshProcess()
      } else {
        this.sortType = 'desc'
        this.queryBackgroundTask()
        this.isSelectAll = false
        this.refreshProcess()
      }
    },
    // 批量重试及还原
    handleBatch(type) {
      const status = type === 'retry' ? this.$t('Retry') : this.$t('Restore')
      if (this.selectRow && this.selectRow.length) {
        this.$confirm(
          `${this.$t('thisOperationWillBeBatched')}${status}, ${this.$t('whetherToContinue')}?`,
          this.$t('hint'),
          {
            confirmButtonText: this.$t('Sure'),
            cancelButtonText: this.$t('Cancel'),
            type: 'warning',
          }
        ).then(() => {
          if (type === 'retry') {
            this.parseQueue = _.filter(this.selectRow, (item) => {
              const params = item.params ? JSON.parse(item.params) : {}
              const modelType = params.FileName?.split('.').at(-1).toLowerCase()
              if (this.modelType.includes(modelType) && !params.TagCount && this.config.isVulkan) {
                this.parseQueue.push(item)
                return true
              }
              return false
            })
          }
          const ids = []
          const otherRow = _.differenceWith(this.selectRow, this.parseQueue, _.isEqual)
          _.forEach(otherRow, (item) => {
            ids.push({
              id: item.id,
              title: item.title,
              remark: item.remark,
              state: type === 'retry' ? 8 : 16,
            })
          })
          if (ids.length) {
            this.batchEditTaskRequest(ids)
          } else if (this.parseQueue.length) {
            this.parseModelTag()
          }
        })
      } else {
        this.$message.info(`请勾选需要${status}的项`)
      }
    },
    // 批量修改重试及还原的请求
    async batchEditTaskRequest(data) {
      const res = await this.apiBackgroundTask({
        method: 'batch',
        params: data,
      })
      if (this.parseQueue.length && this.config.isVulkan) {
        this.parseModelTag()
      } else if (res && res.code === 0) {
        this.$message({
          message: res.msg,
          type: 'success',
          duration: 2000,
        })
        this.queryBackgroundTask()
      } else {
        this.$message({
          type: 'warning',
          message: res.msg,
          duration: 2000,
        })
      }
    },
    // 重试及还原操作(单个)
    editTask(row, type) {
      if (row.state === 4 && row.taskType === 'PdfFileOcrConvertJob') {
        this.$message.warning(
          `${this.$t('theCompletedPdfFileConversionOcrTypeCanNoLongerBeOperated')}!`
        )
        return
      }
      const status = type === 'retry' ? this.$t('Retry') : this.$t('Restore')
      this.$confirm(
        `${this.$t('thisOperationWillBe')}${status}, ${this.$t('whetherToContinue')}?`,
        this.$t('hint'),
        {
          confirmButtonText: this.$t('Sure'),
          cancelButtonText: this.$t('Cancel'),
          type: 'warning',
        }
      ).then(async () => {
        if (type === 'retry') {
          try {
            const params = JSON.parse(row.params)
            const modelType = params.FileName.split('.').at(-1).toLowerCase()
            if (this.modelType.includes(modelType) && !params.TagCount && this.config.isVulkan) {
              this.parseQueue.push(row)
              this.parseModelTag()
              return
            }
          } catch (error) {
            console.log(error)
          }
        }
        const param = {
          id: row.id,
          title: row.title,
          remark: row.remark,
          state: type === 'retry' ? 8 : 16,
        }
        this.editTaskRequest(param, type)
      })
    },
    // 重试\还原发送的请求(单个)
    async editTaskRequest(data, type) {
      const res = await this.apiBackgroundTask({
        method: `${type}`,
        params: data,
      })
      if (res && res.code === 0 && res.data) {
        this.$message({
          message: res.msg,
          type: 'success',
          duration: 2000,
        })
        this.queryBackgroundTask()
      } else {
        this.$message({
          type: 'warning',
          message: res.msg,
          duration: 2000,
        })
      }
    },

    // 查看操作
    async viewTask(row) {
      switch (row.indentifyType) {
        case 1:
          {
            const res = await this.apiBackgroundTask({
              method: 'view',
              params: row.indentifyId,
            })
            if (res.data && res && res.code === 0) {
              // this.$router.push({
              //   path: `/assetsBrowse/documentObjectBrowse/${data.documentId}`,
              // })

              if (this.modelCenterVersion === 'v1') {
                // old version
                window.open(
                  `/static/docBrowse/home.html?documentId=${res.data.documentId}&fileId=${row.indentifyId}`
                )
                return
              }
              const docBasicAttrRes = await DocumentService.findDocAttr({
                id: res.data.documentId,
                standardId: this.standardId,
              })
              const fileRes = await DocumentService.getDocumentFileType({
                fileId: docBasicAttrRes.data.defaultFileId,
                isVersion: false,
                standardId: this.standardId,
              })
              const fileNameType = _.split(fileRes.data.fileName, '.')
              if (this.modelCenterVersion === 'v3' || _.last(fileNameType) !== 'pr') {
                // 云渲染
                window.routerTrigger = 'noCache'
                this.$router.push(
                  `${this.basePath}/docView?documentId=${res.data.documentId}&title=${encodeURIComponent(
                    fileRes.data.fileName
                  )}`
                )
              }
              if (this.modelCenterVersion === 'v4' && _.last(fileNameType) === 'pr') {
                // 云渲染全屏版本
                window.routerTrigger = 'noCache'
                const routerData = this.$router.resolve({
                  name: 'modelDocView',
                  query: {
                    documentId: res.data.documentId,
                    title: encodeURIComponent(fileRes.data.fileName),
                  },
                })
                window.open(routerData.href, '_blank')
              }
            }
          }
          break
        case 2:
          localforage.setItem('tagId', row.indentifyId)
          window.routerTrigger = 'noCache'
          const res = await this.apiTags({
            method: 'tags',
            params: { tagId: row.indentifyId, pageNo: 1, pageSize: 10000 },
          })
          this.$router.push(
            `${this.basePath}/assetsBrowse/tagObjectView?id=${row.indentifyId}&title=${res.model.tag.code}`
          )
          break
        case 4:
          if (row.state === 4) {
            const config = { responseType: 'arraybuffer' }
            const instance = axios.create(config)
            const resData = await instance.get(
              `${currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${row.indentifyId}`
            )
            this.downLoadBlob({
              name: row.name,
              type: resData.headers['content-type'],
              data: resData.data,
            })
          } else {
            this.$message(`${this.$t('conversionNotCompleteWaitAmoment')}!`)
          }
          break
        default:
      }
    },

    //  刷新进度
    async refreshProcess() {
      const timerData = await this.apiBackgroundTask({
        method: 'list',
        params: {
          Title: this.keywords,
          SkipCount: (this.pageNo - 1) * this.pageSize,
          MaxResultCount: this.pageSize,
          Sorting: `${this.sortName} ${this.sortType}`,
          JobState: this.taskJobStateType,
          JobType: this.jobType,
          CreateStartTime: _.isEmpty(this.createdTime) ? '' : this.createdTime[0],
          CreateEndTime: _.isEmpty(this.createdTime) ? '' : this.createdTime[1],
          ModifyStartTime: _.isEmpty(this.modifiedTime) ? '' : this.modifiedTime[0],
          ModifyEndTime: _.isEmpty(this.modifiedTime) ? '' : this.modifiedTime[1],
          standardId: this.standardId,
        },
      })
      if (timerData && timerData.code === 0 && timerData.data) {
        const data = _.filter(timerData.data, (i) => {
          return i.progess < 100
        })
        if (data && data.length > 0) {
          _.forEach(data, (i) => {
            _.forEach(this.tableData, (item) => {
              if (i.id === item.id) {
                item.progess = i.progess
                item.stateStr = i.stateStr
              }
            })
          })
        } else {
          clearInterval(this.timer)
        }
      } else {
        clearInterval(this.timer)
      }
    },
    // 计时器
    setTimer() {
      this.timer = setInterval(() => {
        this.refreshProcess()
      }, 15000)
    },
    // 监控路由
    watchRouter() {
      if (this.$route.path !== '/mainData/BackgroundTaskManagement') {
        clearInterval(this.timer)
      }
      if (this.$route.path === '/mainData/BackgroundTaskManagement') {
        this.setTimer()
      }
    },
    // 删除
    deleteTaskJob(data) {
      if (data.length === 0) {
        this.$message.warning(`${this.$t('pleaseSelectTheDataToDelete')}!`)
        return
      }
      const normalData = _.find(data, (item) => {
        return item.state !== -1
      })
      if (normalData) {
        this.$message.warning(
          `${this.$t('theSelectedDataContainsDataWithAStatusOtherThanFailed')}!`
        )
        return
      }
      this.$confirm(
        `${this.$t('operationWillPermanentlySelectTheDataWhetherToContinue')}?`,
        this.$t('hint'),
        {
          confirmButtonText: this.$t('Sure'),
          cancelButtonText: this.$t('Cancel'),
          type: 'warning',
        }
      )
        .then(async () => {
          const ids = []
          _.forEach(data, (item) => {
            ids.push(item.id)
          })
          const res = await this.apiBackgroundTask({
            method: 'delete',
            params: ids,
          })
          if (res && res.code === 0) {
            this.$message.success(`${this.$t('successfullyDeleted')}!`)
            this.handleRefresh()
          }
        })
        .catch(() => {})
    },
  },
  async created() {
    this.typeOptions = await this.queryTaskType()
    this.jobTypeData = await this.queryJobType()
    if (this.standardId) {
      this.queryBackgroundTask()
      this.setTimer()
    }
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
  mounted() {
    this.$nextTick(() => {
      const obj = {}
      _.forIn(this.$refs.searchBar, (val, key) => {
        obj[key] = val
      })
    })
  },
  watch: {
    $route: 'watchRouter',
    standardId(newVal) {
      if (newVal) {
        this.queryBackgroundTask()
        if (this.timer) {
          clearInterval(this.timer)
        }
        this.setTimer()
      }
    },
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  mixins: [ApiMixinBackgroundTask, fnMixin, ApiMixinTags],
}
</script>
<style scoped lang="scss">

.search-bar {
  align-items: center;
  .flex-1 {
    min-width: 150px;
  }
}
/deep/ .el-date-editor--daterange.el-input__inner {
  width: 300px;
  .el-range-separator {
    width: auto;
  }
}

</style>
